/* eslint-disable import/no-anonymous-default-export */
import {
    GET_ALL_MANUFACTURER_REVIEWS_PAGE,
    GET_ALL_MANUFACTURER_REVIEWS_PAGE_ERROR,
    GET_MANUFACTURER_REVIEW_COUNT,
    GET_MANUFACTURER_REVIEW_COUNT_ERROR,
    SEARCH_MANUFACTURER_REVIEWS,
    SEARCH_MANUFACTURER_REVIEWS_ERROR,
    SELECT_MANUFACTURER_REVIEW,
    ADD_MANUFACTURER_REVIEW,
    UPDATE_MANUFACTURER_REVIEW,
    DELETE_MANUFACTURER_REVIEW,
    GET_FILTERED_MANUFACTURER_REVIEWS,
    GET_FILTERED_MANUFACTURER_REVIEWS_ERROR,
    SET_MANUFACTURER_REVIEWS_LIST_IS_LOADING_TRUE,
    GET_MANUFACTURER_REVIEW_SEARCH_COUNT,
    GET_MANUFACTURER_REVIEW_SEARCH_COUNT_ERROR,
} from "../actions/types";

const initialState = {
    manufacturer: null,
    isLoading: true,
    success: false,
    count: null,
    filteredManufacturerReviews: [],
    filteredManufacturerReviewsCount: null,


    isLoadingManufacturerReviewsList: true,
    manufacturerReviews: [],
    manufacturerReviewsCount: null,
    manufacturerReviewSearch: [],
    manufacturerReviewSearchCount: null,
    selectedManufacturerReview: null,
};

export default function (state = initialState, action) {
    const { payload, type } = action;

    switch (type) {


        case SET_MANUFACTURER_REVIEWS_LIST_IS_LOADING_TRUE:
            return {
                ...state,
                isLoadingManufacturerReviewsList: true,
                success: true,
            };
        case GET_ALL_MANUFACTURER_REVIEWS_PAGE:
            return {
                ...state,
                manufacturerReviews: payload,
                isLoadingManufacturerReviewsList: false,
                success: true
            };
        case GET_ALL_MANUFACTURER_REVIEWS_PAGE_ERROR:
            return {
                ...state,
                manufacturerReviews: payload,
                isLoadingManufacturerReviewsList: false,
                success: true
            };
        case GET_MANUFACTURER_REVIEW_COUNT:
            return {
                ...state,
                manufacturerReviewsCount: payload,
                isLoading: false,
                success: true,
            };
        case GET_MANUFACTURER_REVIEW_COUNT_ERROR:
            return {
                ...state,
                manufacturerReviewsCount: payload,
                isLoading: false,
                success: false,
            }
        case SEARCH_MANUFACTURER_REVIEWS:
            return {
                ...state,
                manufacturerReviewSearch: payload,
                isLoadingManufacturerReviewsList: false,
            }
        case SEARCH_MANUFACTURER_REVIEWS_ERROR:
            return {
                ...state,
                manufacturerReviewSearch: payload,
                isLoadingManufacturerReviewsList: false,
            }
        case GET_MANUFACTURER_REVIEW_SEARCH_COUNT:
            return {
                ...state,
                manufacturerReviewSearchCount: payload,
                isLoading: false,
                success: false,
            }
        case GET_MANUFACTURER_REVIEW_SEARCH_COUNT_ERROR:
            return {
                ...state,
                manufacturerReviewSearchCount: payload,
                isLoading: false,
                success: false,
            }
        case SELECT_MANUFACTURER_REVIEW:
            return {
                ...state,
                selectedManufacturerReview: payload
            }






        case GET_FILTERED_MANUFACTURER_REVIEWS:
            return {
                ...state,
                filteredManufacturerReviews: payload.rows,
                filteredManufacturerReviewsCount: payload.count,
                isLoading: false,
                success: true
            };
        case GET_FILTERED_MANUFACTURER_REVIEWS_ERROR:
            return {
                ...state,
                filteredManufacturerReviews: null,
                filteredManufacturerReviewsCount: null,
                isLoading: false,
                success: false
            };
        
        
        
        
        case UPDATE_MANUFACTURER_REVIEW:
        case DELETE_MANUFACTURER_REVIEW:
        case ADD_MANUFACTURER_REVIEW:
            return {
                ...state,
                isLoading: false,
                success: true,
            };
        

        default:
            return state;
    }
}